module.exports = __webpack_public_path__ + "static/media/DR3.3b6add03.avif";